var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramIcon = function SvgTelegramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.162 4.611s2.105-.852 1.93 1.218c-.059.852-.585 3.835-.994 7.06l-1.403 9.557s-.117 1.4-1.17 1.644c-1.052.243-2.63-.852-2.923-1.096-.233-.182-4.384-2.921-5.845-4.26-.41-.366-.877-1.096.058-1.949l6.138-6.087c.702-.73 1.403-2.434-1.52-.365L9.25 16.116s-.935.609-2.69.06l-3.8-1.217s-1.402-.913.995-1.826C9.6 10.273 16.79 7.35 23.162 4.611"
  })));
};
export default SvgTelegramIcon;